import fetchApi from "common/utils/api/fetchApi";

export const updateMeeting = (meetingId, fields) => fetchApi('/meeting/'+meetingId, {
    method: 'PATCH',
    body: fields
})